const deg2rad = (deg: number) => deg * (Math.PI / 180);

const getDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

const sortByDistance = (
  pois: [{ lat: number; lng: number }],
  coord: { lat: number; lng: number },
) => {
  return pois.sort((a, b) => {
    const aDistance = getDistance(coord.lat, coord.lng, a.lat, a.lng);
    const bDistance = getDistance(coord.lat, coord.lng, b.lat, b.lng);
    if (aDistance - bDistance > 0) {
      return 1;
    } else if (aDistance - bDistance < 0) {
      return -1;
    } else {
      return 0;
    }
  });
};

export { getDistance, sortByDistance };
